import DocumentFilterSvg from '../../../assets/images/document-filter.svg';
import SummaryFilterSvg from '../../../assets/images/summary-filter.svg';
import ProfileSvg from '../../../assets/images/profile.svg';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export const GovResubmitProfileStep = () => {
    const { t } = useTranslation();
    let { domainId } = useParams();
    return (
        <nav aria-label="breadcrumb">
            <ol className="d-flex breadcrumb col-xl-12 mx-auto">
                <li className="active"><Link to={`/government-resubmit/profile/${domainId}`}><span className="circle"><img src={ProfileSvg} width="30px" alt='' /></span>{t('ProfileText')}</Link></li>
                <li><a href="/#" className="disabled"><span className="circle"><img src={DocumentFilterSvg} width="30px" alt='' /></span>{t('DocumentText')}</a></li>
                <li><a href="/#" className="disabled"><span className="circle"><img src={SummaryFilterSvg} width="30px" alt='' /></span>{t('SummaryText')}</a></li>
            </ol>
        </nav>

    )
}